import React from 'react';
import { Grid } from '@mui/material';

import { Icon, useSettings, Utils } from 'app/main/components';
import {
	DetailsSectionDescription,
	DetailsSectionFlow,
	DetailsSectionInfoWrapper,
	type DetailsPageContentProps
} from 'app/main/components/page-layouts';
import DetailsSectionBilling from 'app/main/modules/components/DetailsSectionBilling';
import DetailsSectionShipping from 'app/main/modules/components/DetailsSectionShipping';

import OrdersDetailsSectionInfo from '../sections/OrdersDetailsSectionInfo';
import OrdersDetailsSectionSecondaryInfo from '../sections/OrdersDetailsSectionSecondaryInfo';

export default function OrdersDetailsTab(props: DetailsPageContentProps) {
	const { t } = useSettings();

	const canEditFull = Utils.getConnectionFromToken() !== 'PERCEPTIVE_CONTROL_BEB';

	return (
		<Grid container spacing={2}>
			<Grid size={{ lg: 8, xs: 12 }}>
				<Grid container spacing={2}>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_INFO_SECTION')}
							subheader={t('DETAILS_INFO_SUBHEADER')}
						>
							<OrdersDetailsSectionInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								isAdd={props.isAdd}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					<Grid size={12}>
						<DetailsSectionInfoWrapper
							avatar={<Icon icon="text-subject" />}
							title={t('DETAILS_SECONDARY_INFO_SECTION')}
							subheader={t('DETAILS_SECONDARY_INFO_SUBHEADER')}
						>
							<OrdersDetailsSectionSecondaryInfo
								model={props.model}
								sendChange={props.sendChange}
								isEdit={props.isEdit}
								logProps={props.logProps}
							/>
						</DetailsSectionInfoWrapper>
					</Grid>
					{/* <Grid size={12}>
						<DetailsSectionDescription
							name="ords_descriptionhtml"
							value={props.model.ords_descriptionhtml}
							isEdit={props.isEdit}
							sendChange={props.sendChange}
							logProps={props.logProps}
						/>
					</Grid>
					<Grid size={12}>
						<DetailsSectionNotes module="orders" uid={props.model.ords_uid} />
					</Grid> */}
					{props.model.comp_ords_noteshtml && (
						<Grid size={12}>
							<DetailsSectionDescription
								name="comp_ords_noteshtml"
								title={t('DETAILS_NOTES_SECTION')}
								subheader={t('DETAILS_NOTES_SUBHEADER')}
								value={props.model.comp_ords_noteshtml}
								// isEdit={props.isEdit}
								sendChange={props.sendChange}
								logProps={props.logProps}
							/>
						</Grid>
					)}
					{(props.model.ords_commentshtml || props.isEdit) && (
						<Grid size={12}>
							<DetailsSectionDescription
								name="ords_commentshtml"
								title={t('DETAILS_COMMENTS_SECTION')}
								subheader={t('DETAILS_COMMENTS_SUBHEADER')}
								value={props.model.ords_commentshtml}
								isEdit={props.isEdit}
								sendChange={props.sendChange}
								logProps={props.logProps}
							/>
						</Grid>
					)}
				</Grid>
			</Grid>
			<Grid size={{ lg: 4, xs: 12 }}>
				<Grid container spacing={2}>
					{props.model.ords_comp_uid && (
						<>
							<Grid size={12}>
								<DetailsSectionInfoWrapper
									avatar={<Icon icon="credit-card" />}
									title={t('DETAILS_BILLING_COMPANY_SECTION')}
									subheader={t('DETAILS_BILLING_COMPANY_SUBHEADER')}
								>
									<DetailsSectionBilling
										module="orders"
										model={props.model}
										isEdit={props.isEdit && canEditFull}
										sendChange={props.sendChange}
									/>
								</DetailsSectionInfoWrapper>
							</Grid>
							<Grid size={12}>
								<DetailsSectionInfoWrapper
									avatar={<Icon icon="truck" />}
									title={t('DETAILS_SHIPPING_ADDRESS_SECTION')}
									subheader={t('DETAILS_SHIPPING_ADDRESS_SUBHEADER')}
								>
									<DetailsSectionShipping
										module="orders"
										model={props.model}
										isEdit={props.isEdit}
										sendChange={props.sendChange}
										editableAddress={canEditFull}
									/>
								</DetailsSectionInfoWrapper>
							</Grid>
						</>
					)}
					<Grid size={12}>
						<DetailsSectionFlow
							module="orders"
							model={props.model}
							isEdit={props.isEdit}
							sendChange={props.sendChange}
							logProps={props.logProps}
						/>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}
